'use client';

import { DatePicker } from '@koda/koda-components/molecules/DatePicker';
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';
import { ReactElement } from 'react';
import { LicenseTypes } from '../../../types/licenses';
import { useLicenseBusiness } from '../hooks/useLicenseBusiness';
import { Past5Years } from './consts/dateIntervals';
import { createGymnasticsDefaults, GYMNASTICS_CONTENT_PATH, gymnasticsSchema } from './gymnastics.Schema';

export default function GymnasticsComponent(): ReactElement {
  const licenseCode = LicenseTypes.Gymnastics;

  const { values, setField, getError, costCalculated, showErrors } = useLicenseBusiness(licenseCode, {
    schema: gymnasticsSchema,
    defaults: createGymnasticsDefaults,
  });

  const t = useTranslations(GYMNASTICS_CONTENT_PATH);

  return (
    <>
      <DatePicker
        label={t('eventDate.label')}
        name="eventDate"
        placeholder={t('eventDate.placeholder')}
        disabled={costCalculated}
        value={values.eventDate && values.eventDate !== '' ? new Date(values.eventDate) : undefined}
        onChange={date => setField('eventDate', date ? dayjs(date).format('YYYY-MM-DD') : '')}
        error={values.eventDate || showErrors ? getError('eventDate') : undefined}
        validated={!!values.eventDate && !getError('eventDate')}
        initialVisibleValue={new Date()}
        interval={Past5Years}
      />
    </>
  );
}
